module.exports = {
	"error": {
		"message": "Sorry, an error has occurred. To keep going, chat live to our team, or you can try again later.",
		"actionText": "Try Again",
		"iconClassName": "address-search-unavailable-icon"
	},
	"unavailable": {
		"message": "Skinny Unlimited Broadband is not available at your place. You still might be able to get",
		"messageLink": {
			"href": "https://www.skinny.co.nz/broadband/",
			"text": "Skinny Wireless Broadband."
		},
		"actionText": "Change address",
		"iconClassName": "address-search-unavailable-icon"
	},
	"ufbAvailable": {
		"message": "Got it! You're all good to go with Skinny Broadband at your place! We just need to get fibre installed first. To get the ball rolling, just complete the next few questions. We'll take care of the rest.​",
		"actionText": "Change address",
		"iconClassName": "address-search-success-icon"
	},
	"ufbReady": {
		"message": "Got it! You're all good to go with Skinny Broadband as Fibre is already installed at your place! To get the ball rolling, just complete the next few questions. We'll take care of the rest.​",
		"actionText": "Change address",
		"iconClassName": "address-search-success-icon"
	},
	"success": {
		"message": "Got it! You're all good to go with Skinny Broadband at your place!",
		"actionText": "Change address",
		"iconClassName": "address-search-success-icon"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddressSearch/AddressSearchMessages/Messages.json
 ** module id = 1371
 ** module chunks = 0
 **/